// Func = limiting Scope for this file
var lastScrollTop = 0;

var opened = 0;
var start = $('#altIn').attr('value');
var end = $('#altOut').attr('value');
(function(){

	/* Disabled booking widget
	if(document.getElementById('closeBooking')){
		document.getElementById('closeBooking').addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('bookingContainer').classList.remove('open')
		})
		document.getElementById('bookingCta').addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('bookingContainer').classList.add('open')
		})
	} */

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		

		//menu open
		$(".toggle-menu").click(function() {
			$(this).toggleClass("active");
			$('.navigation-js').toggleClass("open");
			$('.menu-cta__logo').toggleClass("no-show");
			$('.third-nav').toggleClass("no-show");
		});
		$('.privary-navigation li:has(ul)').addClass('has-child');

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		let dateFormat = '';
		if($('#bookingCalendar').hasClass('booking-with-calendar')){
			dateFormat = 'yymmdd';
		} else {
			dateFormat = 'yy-mm-dd';
		}
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: dateFormat,
			numberOfMonths: 1,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = dateFormat;
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				
			
			},
			onChangeMonthYear: function () {
				
			}
		});

		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight; let animatedEl = document.getElementsByClassName('animate'); for (let i = 0; i < animatedEl.length; i++) { var viewportOffset = animatedEl[i].getBoundingClientRect(); let topPos = viewportOffset.top; if(topPos <= window_height*0.8){ animatedEl[i].classList.add('fade-in'); } }
}